import { CORNER_RADIUS_SIGN, INCH_QUOTE } from '../constants';

/**
 * Formats a corner radius label based on the provided radius.
 */
export const formatCornerRadiusLabel = (cornerSize: number): string =>
  ` ${CORNER_RADIUS_SIGN} ${cornerSize} ${INCH_QUOTE}`;
